<div class="h-100 box d-flex flex-column">
    <div [ngClass]="[uploadContentType ? 'upload-content-padding' : 'px-4']">
        <ng-container *ngIf="!uploadContentType; else uploadContentTitle">
            <div class="text-l font-semi-bold border-b border-grey-v5 pb-5">{{ 'v3-byoc-popup-create-episode-title' | translate }}</div>
        </ng-container>
        <ng-template #uploadContentTitle>
            <div class="text-l font-bold border-b border-grey-v5 pb-5">
                {{
                    uploadContentType === 'video'
                        ? ('v3-byoc-popup-create-episode-upload-video-title' | translate)
                        : ('v3-byoc-popup-create-episode-upload-document-title' | translate)
                }}
            </div>
        </ng-template>
    </div>

    <div class="flex-grow-1">
        <div class="py-4">
            <div class="inner relative text-grey-v6" [ngClass]="[uploadContentType ? 'upload-content-padding' : 'px-4']" #box>
                <app-message-block></app-message-block>

                <div class="d-flex align-items-center mb-4 bg-dark rounded text-default text-s font-semi-bold p-2" *ngIf="cannotEmbedVideo">
                    <div class="icon icon-xl icon-info me-2" inlineSVG="assets/icons.svg#alert-info"></div>
                    {{ 'v3-byoc-popup-create-episode-info-cennot-embed-video' | translate }}
                </div>

                <ng-container *ngIf="!uploadContentType; else uploadContentIcon">
                    <div class="mb-4" elementDataTest="episodeTypesDrodpown">
                        <div class="d-flex align-items-center mb-2">
                            <div class="d-block text-s font-semi-bold me-1" translate>v3-byoc-episode-type-input-label</div>
                        </div>
                        <app-forms-dropdown-ac
                            [ariaLabelText]="'v3-byoc-episode-type-input-label' | translate"
                            class="d-inline-block"
                            [control]="controlType"
                            [items]="episodeTypesOptions"
                        ></app-forms-dropdown-ac>
                    </div>

                    <!-- Link -->
                    <div class="mb-4">
                        <label class="d-block text-s font-semi-bold">{{ 'v3-byoc-popup-create-episode-fetch-link-label' | translate }}</label>
                        <input
                            [ariaLabel]="'v3-byoc-popup-create-episode-fetch-link-label' | translate"
                            (keydown.enter)="next()"
                            class="w-100 dark-solid"
                            type="text"
                            [formControl]="controlLink"
                            formControlDataTest="episodeLink"
                        />
                    </div>
                </ng-container>
                <ng-template #uploadContentIcon>
                    <div class="d-flex align-items-center mb-2">
                        <div class="d-block text-s font-semi-bold me-1" translate>v3-byoc-episode-type-input-label</div>
                    </div>
                    <div class="d-flex align-items-center upload-content-icon-box">
                        <span
                            class="icon icon-l me-2"
                            [inlineSVG]="uploadContentType === 'video' ? 'assets/icons.svg#content-video' : 'assets/icons.svg#content-document'"
                        ></span>
                        <div class="text-s font-semi-bold" translate>
                            {{ uploadContentType === 'video' ? ('v3-global-video' | translate) : ('v3-global-document' | translate) }}
                        </div>
                    </div>
                </ng-template>

                <!-- Name -->
                <div class="mb-4">
                    <label class="d-block text-s font-semi-bold" translate>v3-byoc-popup-create-episode-fetch-name-label</label>
                    <input
                        (keydown.enter)="next()"
                        class="w-100 info grey-v6-solid text-xs font-bold"
                        [style.height.rem]="2.188"
                        type="text"
                        [formControl]="controlTitle"
                        [ngClass]="{ 'danger-solid': controlTitle.invalid && controlTitle.dirty }"
                        [placeholder]="'v3-byoc-popup-create-episode-fetch-name-placeholder' | translate"
                        formControlDataTest="episodeTitle"
                    />
                </div>

                <!-- Duration -->
                <ng-container *ngIf="durationLoaded; then durationWithSeconds; else durationWithoutSeconds"></ng-container>
                <ng-template #durationWithSeconds>
                    <div class="mb-4">
                        <label class="d-flex align-items-center">
                            <span class="d-block text-s font-semi-bold me-2" translate>{{
                                uploadContentType === 'video'
                                    ? ('v3-global-duration' | translate)
                                    : ('v3-byoc-popup-create-episode-fetch-duration-label' | translate)
                            }}</span>
                            <span
                                *ngIf="uploadContentType !== 'video'"
                                [ariaLabel]="'v3-byoc-popup-create-episode-fetch-duration-tooltip' | translate"
                                tabbable
                                role="tooltip"
                                class="icon icon-l icon-default"
                                [ngbTooltip]="'v3-byoc-popup-create-episode-fetch-duration-tooltip' | translate"
                                container="body"
                                inlineSVG="assets/icons.svg#help-2"
                            ></span>
                        </label>
                        <div class="d-flex align-items-center">
                            <span class="text-capitalize text-xs font-semi-bold time-margin" translate>v3-time-hours</span>
                            <input
                                [ariaLabel]="'v3-byoc-popup-create-episode-fetch-duration-hour' | translate"
                                (keydown.enter)="next()"
                                class="info number grey-v6-solid hours-input px-1 text-xs font-bold"
                                type="text"
                                [formControl]="control(controlDuration.get('h'))"
                                [ngClass]="{ 'danger-solid': controlDuration.get('h')?.invalid && controlDuration.get('h')?.dirty }"
                                [placeholder]="'v3-byoc-popup-create-episode-duration-hh-input-placeholder' | translate"
                                formControlDataTest="durationHours"
                            />
                            <span class="text-capitalize text-xs font-semi-bold time-margin" translate>v3-time-minutes</span>
                            <input
                                [ariaLabel]="'v3-byoc-popup-create-episode-fetch-duration-minutes' | translate"
                                (keydown.enter)="next()"
                                class="info number grey-v6-solid minutes-input px-1 text-xs font-bold"
                                type="text"
                                [formControl]="control(controlDuration.get('m'))"
                                [ngClass]="{ 'danger-solid': controlDuration.get('m')?.invalid && controlDuration.get('m')?.dirty }"
                                [placeholder]="'v3-byoc-popup-create-episode-duration-mm-input-placeholder' | translate"
                                formControlDataTest="durationMinutes"
                            />
                            <span class="text-capitalize text-xs font-semi-bold time-margin" translate>v3-time-seconds</span>
                            <input
                                (keydown.enter)="next()"
                                class="info number grey-v6-solid px-1 text-xs font-bold"
                                type="text"
                                [formControl]="control(controlDuration.get('s'))"
                                [ngClass]="{ 'danger-solid': controlDuration.get('s')?.invalid && controlDuration.get('s')?.dirty }"
                                [placeholder]="'v3-byoc-popup-create-episode-duration-ss-input-placeholder' | translate"
                                formControlDataTest="durationSeconds"
                            />
                        </div>
                    </div>
                </ng-template>
                <ng-template #durationWithoutSeconds>
                    <div class="mb-4">
                        <label class="d-flex align-items-center flex-wrap">
                            <span class="d-block text-s font-semi-bold me-2" translate>v3-byoc-popup-create-episode-fetch-duration-label</span>
                            <span
                                [ariaLabel]="'v3-byoc-popup-create-episode-fetch-duration-tooltip' | translate"
                                tabbable
                                role="tooltip"
                                class="icon icon-l icon-default"
                                [ngbTooltip]="'v3-byoc-popup-create-episode-fetch-duration-tooltip' | translate"
                                container="body"
                                inlineSVG="assets/icons.svg#help-2"
                            ></span>
                        </label>
                        <div class="d-flex align-items-center">
                            <input
                                [ariaLabel]="'v3-byoc-popup-create-episode-fetch-duration-hour' | translate"
                                (keydown.enter)="next()"
                                class="info number me-1 grey-v6-solid px-1 text-xs font-bold"
                                type="text"
                                [formControl]="control(controlDuration.get('h'))"
                                [ngClass]="{ 'danger-solid': controlDuration.get('h')?.invalid && controlDuration.get('h')?.dirty }"
                                [placeholder]="'v3-byoc-popup-create-episode-duration-hh-input-placeholder' | translate"
                                formControlDataTest="durationHours"
                            />
                            <input
                                [ariaLabel]="'v3-byoc-popup-create-episode-fetch-duration-minutes' | translate"
                                (keydown.enter)="next()"
                                class="info number me-4 grey-v6-solid px-1 text-xs font-bold"
                                type="text"
                                [formControl]="control(controlDuration.get('m'))"
                                [ngClass]="{ 'danger-solid': controlDuration.get('m')?.invalid && controlDuration.get('m')?.dirty }"
                                [placeholder]="'v3-byoc-popup-create-episode-duration-mm-input-placeholder' | translate"
                                formControlDataTest="durationMinutes"
                            />
                            <div class="text-s font-semi-bold" translate>v3-byoc-popup-create-episode-fetch-duration-without-seconds-example</div>
                        </div>
                    </div>
                </ng-template>

                <!-- Summary/Description/Content -->
                <div class="mb-4">
                    <label class="d-flex align-items-center">
                        <span class="d-block text-s font-semi-bold me-2">{{
                            uploadContentType === 'video'
                                ? ('v3-byoc-popup-create-episode-upload-video-transcript' | translate)
                                : ('v3-episode-menu-transcript' | translate)
                        }}</span>
                        <span
                            [ariaLabel]="'v3-byoc-popup-create-episode-summary-tooltip' | translate"
                            role="tooltip"
                            tabbable
                            class="icon icon-l icon-default"
                            [ngbTooltip]="'v3-byoc-popup-create-episode-summary-tooltip' | translate"
                            container="body"
                            inlineSVG="assets/icons.svg#help-2"
                        ></span>
                    </label>
                    <textarea
                        [ariaLabel]="'v3-byoc-popup-create-episode-fetch-summary-label' | translate"
                        tabbable
                        class="w-100 info grey-v6-solid"
                        [formControl]="controlContent"
                        [ngClass]="{ 'danger-solid': controlContent.invalid && controlContent.dirty, 'transcript-placeholder': uploadContentType === 'video' }"
                        [placeholder]="
                            uploadContentType === 'video'
                                ? ('v3-byoc-popup-create-episode-upload-video-transcript-placeholder' | translate)
                                : ('v3-byoc-popup-create-episode-fetch-summary-placeholder' | translate)
                        "
                        formControlDataTest="episodeDescription"
                    ></textarea>
                </div>

                <div *ngIf="uploadContentType === 'video'">
                    <app-upload-subtitles-list [subtitles]="subtitlesArrayForm" (validatingEvent)="onValidating($event)"></app-upload-subtitles-list>
                </div>

                <!-- Skills -->
                <div class="mb-4">
                    <label class="d-block text-s font-semi-bold" translate>v3-byoc-popup-create-episode-general-select-skills</label>
                    <app-gamification-form-input-skills
                        [controlSkillIds]="controlSkills"
                        [episodeSkills]="selectedEpisodeSkills"
                        (selectedSkillsEvent)="selectedSkills($event)"
                        [classes]="'grey-v6-solid'"
                    ></app-gamification-form-input-skills>
                </div>

                <div class="border border-grey-v6 rounded">
                    <div
                        [ariaExpanded]="open"
                        tabbable
                        role="button"
                        (focus)="openTooltip()"
                        (blur)="closeTooltip()"
                        class="d-flex align-items-center p-4 pointer"
                        (enterKeyUp)="toggleOpen()"
                        (click)="toggleOpen()"
                        buttonDataTest="toggleQuestionButton"
                    >
                        <div class="icon icon-xxl icon-default me-2" inlineSVG="assets/icons.svg#quiz"></div>
                        <div class="text-uppercase font-semi-bold text-default text-s me-2" translate>v3-byoc-popup-create-episode-questions-title</div>
                        <div
                            #addQuestionTooltip="ngbTooltip"
                            [ariaLabel]="'v3-byoc-popup-create-episode-questions-title-tooltip' | translate"
                            role="tooltip"
                            class="icon icon-l icon-default"
                            [ngbTooltip]="'v3-byoc-popup-create-episode-questions-title-tooltip' | translate"
                            container="body"
                            inlineSVG="assets/icons.svg#help-2"
                        ></div>
                        <div
                            class="icon icon-default icon-xs ms-auto"
                            [ngClass]="[open ? 'rotate-270' : 'rotate-90']"
                            inlineSVG="assets/icons.svg#arrow-right-tall"
                        ></div>
                    </div>

                    <div *ngIf="open" class="ps-7">
                        <app-byoc-episode-step-fetch-questions [formArray]="controlQuestions"></app-byoc-episode-step-fetch-questions>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="theme-new d-flex align-items-center" [ngClass]="[uploadContentType ? 'upload-content-padding' : 'px-4']">
        <button (click)="cancel()" class="btn ms-auto" [ngClass]="[editing ? 'btn-disabled' : 'btn-primary']" buttonDataTest="cancelButton" translate>
            v3-button-cancel
        </button>
        <button
            *ngIf="!isInCourseCreatingFlow && !skipPosition && !canEditEpisodeAndUploadNewContent; else addButtons"
            (click)="next()"
            class="btn btn-secondary continue"
            [ngClass]="[editing || invalid ? 'btn-disabled' : 'btn-secondary']"
            translate
            buttonDataTest="continueButton"
        >
            v3-button-continue
        </button>
    </div>
</div>

<ng-template #addButtons>
    <ng-container *ngIf="!canEditEpisodeAndUploadNewContent; else reuploadContentButtons">
        <button
            (click)="saveAsDraftClick()"
            class="btn"
            [ngClass]="[!invalid && !saving ? 'btn-secondary' : 'btn-disabled']"
            buttonDataTest="saveAsDraftButton"
            translate
        >
            v3-button-save-as-draft
        </button>
        <button
            (click)="usersClick()"
            class="btn"
            [ngClass]="[!invalid && !saving ? 'btn-secondary' : 'btn-disabled']"
            buttonDataTest="publishButton"
            translate
        >
            v3-button-publish
        </button>
    </ng-container>
    <ng-template #reuploadContentButtons>
        <button
            (click)="reuploadAndSaveAsDraft()"
            class="btn"
            [ngClass]="[!invalid && (reuploadLoading$ | async) === false ? 'btn-secondary' : 'btn-disabled']"
            buttonDataTest="saveAsDraftButton"
            translate
        >
            v3-button-save-as-draft
        </button>
        <button
            (click)="reuploadAndPublish()"
            class="btn"
            [ngClass]="[!invalid && (reuploadLoading$ | async) === false ? 'btn-secondary' : 'btn-disabled']"
            buttonDataTest="publishButton"
            translate
        >
            v3-button-publish
        </button>
    </ng-template>
</ng-template>
